import { type FunctionComponent, type PropsWithChildren } from 'react';
import { badgeStyle, hideCountStyle } from './badge.css';

export type BadgeProps = {
	count: number;
	condensed?: boolean;
	noMargin?: boolean;
	hideCount?: boolean;
	className?: string;
};

export const Badge: FunctionComponent<PropsWithChildren<BadgeProps>> = ({
	count,
	condensed,
	noMargin,
	hideCount,
	children,
	className = ''
}) => {
	const phValue = hideCount ? hideCountStyle : condensed ? 'px-1' : 'px-2';
	const pvValue = !hideCount && !condensed ? 'py-1' : '';
	const hasChildrenStyles = children ? `absolute ${badgeStyle}` : '';
	const wrapperMargin = noMargin ? '' : 'mr-6';
	return (
		<div className={`inline-block relative ${wrapperMargin}`}>
			{children}
			{count !== 0 && (
				<div
					data-testid="badge-count"
					className={`text-xs font-medium top-0 right-0 bg-theme-emphasis theme-white ${phValue} ${pvValue} rounded-full border border-solid b--theme-white ${hasChildrenStyles} ${className}`}>
					{!hideCount && (count < 100 ? count : '99+')}
				</div>
			)}
		</div>
	);
};
